import { giphyDarkestGrey, giphyLightestGrey, giphyLightGrey } from '@giphy/js-brand'
import styled, { css, keyframes } from 'styled-components'
import { MARGIN, SEARCH_HEIGHT } from '../../constants'

export const HEIGHT = SEARCH_HEIGHT - MARGIN - 4 // these needed px tweaks
export const bottomMargin = MARGIN
export const Container = styled.div<{ hide: boolean }>`
    display: flex;
    flex-shrink: 0;
    align-content: center;
    height: ${HEIGHT}px;
    padding: 0 ${MARGIN}px;
    margin: 0 ${MARGIN}px;
    font-weight: bold;
    position: relative;
    overflow: hidden;
    align-items: center;
    margin-bottom: ${bottomMargin}px;
    ${(props) =>
        props.hide &&
        css`
            opacity: 0;
            height: 0;
            margin: 0;
            pointer-events: none;
        `}
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
        display: none;
    }
`
export const Carousel = styled.div<{ width: number }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 10px; /** cover the arrow **/
    bottom: 0;
`

export const categoryAnimation = keyframes`
    from {
        opacity: 0;
        transform: translateY(5px);
    }
    to {
        opacity: 1;
    }
`
export const categoryOutAnimation = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`

export const arrowAnimation = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`

export const TextPill = styled.img`
    align-self: center;
    height: 15px;
    width: 15px;
    margin-left: -6px;
    margin-right: 4px;
`

export const TrendingSearchPillContainer = styled.div<{ isActive: boolean; isText: boolean }>`
    color: ${(props) => (props.isActive ? giphyDarkestGrey : giphyLightGrey)};
    background: ${(props) => (props.isActive ? giphyLightGrey : giphyDarkestGrey)};
    display: flex;
    padding: 4px 12px;
    align-items: center;
    margin-right: ${2}px;
    white-space: nowrap;
    cursor: pointer;
    font-style: italic;
    border-radius: 25px;
    span {
        max-width: 125px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    ${(props) =>
        props.isText &&
        css`
            background-image: linear-gradient(45deg, #5c6fff 0%, #18b5ff 100%);
            color: white;
        `}
    &:hover {
        ${(props) =>
            !props.isActive &&
            css`
                color: ${giphyLightestGrey};
            `}
    }
`

export const Category = styled.div<{ delay: number; fadeOut?: boolean }>`
    display: flex;
    white-space: nowrap;
    cursor: pointer;
    opacity: 0;
    transform: translate3d(0, 0, 0);
    ${(props) =>
        props.fadeOut
            ? css`
                  animation: ${categoryOutAnimation} 0.2s ease-in-out forwards;
              `
            : css`
                  animation: ${categoryAnimation} 0.2s ease-in-out ${props.delay}s forwards;
              `}
`

export const Navigate = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    padding-left: 35px;
    height: 30px;
    background: linear-gradient(90deg, rgba(18, 18, 18, 0) 0%, rgba(18, 18, 18, 1) 60%);
    cursor: pointer;
    animation: ${arrowAnimation} 0.2s ease-in-out;
`

const arrowOffset = -3
export const NavigateForward = styled(Navigate)`
    right: ${arrowOffset}px;
`
export const NavigateBack = styled(Navigate)`
    left: ${arrowOffset}px;
    transform: rotate(180deg);
`
